import {
  UAE_PASS_VERIFIED_PATH,
  UAE_PASS_VERIFIED_VIEWBOX,
} from './uaepass-verified-path';

/**
 * Web variant of the UAE Pass "verified" badge: inline `<svg>` so it composes
 * naturally inside the raw-DOM web screens (headers, CV cards). Defaults to
 * `currentColor` so it inherits the surrounding handle/subtitle text color.
 */
export function UaePassVerifiedBadge({
  size = 14,
  color = 'currentColor',
  opacity = 1,
}: {
  size?: number;
  color?: string;
  /** Dimming for the unverified state; kept at parity with the native sibling. */
  opacity?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={UAE_PASS_VERIFIED_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable={false}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <path d={UAE_PASS_VERIFIED_PATH} fill={color} fillOpacity={opacity} />
    </svg>
  );
}
